import { render, staticRenderFns } from "./FileReleaseAgenda.vue?vue&type=template&id=48d91d45"
import script from "./FileReleaseAgenda.vue?vue&type=script&lang=js"
export * from "./FileReleaseAgenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports